export function createCanvasContext(
  canvas: HTMLCanvasElement,
  device: GPUDevice,
  format: GPUTextureFormat,
): GPUCanvasContext {
  const context = canvas.getContext('webgpu');
  if (!context) {
    throw new Error('Failed to get WebGPU canvas context');
  }

  context.configure({
    device,
    format,
    alphaMode: 'premultiplied',
  });

  return context;
}
